import { createIcon } from "@chakra-ui/react";

const DataArrayIcon = createIcon({
  displayName: "DataArrayIcon",
  viewBox: "0 0 24 24",
  path: <path d="M15 20v-2h3V6h-3V4h5v16ZM4 20V4h5v2H6v12h3v2Z" fill="currentColor" />,
});

export default DataArrayIcon;
